module.exports = __webpack_public_path__ + "static/media/tijuana.2ad54d25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/centers/tijuana.png
// module id = 629
// module chunks = 0